import { reactive } from 'vue'
import { apiFetch } from './api'

export interface Role {
  id: string
  name: string
  isAdmin: boolean
  isAnalyst: boolean
  subordinateRoleIds: string[]
  warehouseAccess: number
  maintenanceAccess: number
  constructionAccess: number
  portariaAccess: number
  createdAt: string
}

const state = reactive({
  items: [] as Role[]
})

function asRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' ? (value as Record<string, unknown>) : {}
}

function mapRole(item: unknown): Role {
  const record = asRecord(item)
  const subordinateRoleIds = Array.isArray(record.subordinateRoleIds)
    ? record.subordinateRoleIds.filter((value): value is string => typeof value === 'string')
    : []
  return {
    id: String(record.id || ''),
    name: String(record.name || ''),
    isAdmin: Boolean(record.isAdmin),
    isAnalyst: Boolean(record.isAnalyst),
    subordinateRoleIds,
    warehouseAccess: Math.max(0, Math.min(3, Number(record.warehouseAccess || 0))),
    maintenanceAccess: Number(record.maintenanceAccess || 0),
    constructionAccess: record.constructionAccess !== undefined && record.constructionAccess !== null ? Number(record.constructionAccess) : 1,
    portariaAccess: Math.max(0, Math.min(3, Number(record.portariaAccess || 0))),
    createdAt: String(record.createdAt || new Date().toISOString())
  }
}

export const rolesStore = {
  state,
  all() {
    return state.items
  },
  async refresh() {
    const rows = await apiFetch<unknown[]>('/roles')
    state.items = rows.map(mapRole)
    return state.items
  },
  async upsert(payload: { id?: string; name: string; isAdmin: boolean; isAnalyst: boolean; subordinateRoleIds: string[]; warehouseAccess: number; maintenanceAccess: number; constructionAccess: number; portariaAccess?: number }) {
    await apiFetch<{ ok: boolean; id: string }>('/roles', {
      method: 'POST',
      body: JSON.stringify(payload)
    })
    await this.refresh()
  }
}
